/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Confirm_Paid_TitleInputs */



/**
* | output |
* | --- |
* | "Mark commission entries as paid?" |
*
* @param {Partner_Admin_Commission_Confirm_Paid_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_confirm_paid_title = /** @type {((inputs?: Partner_Admin_Commission_Confirm_Paid_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Confirm_Paid_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Provisionseinträge als ausgezahlt markieren?")
	return /** @type {LocalizedString} */ ("Mark commission entries as paid?")
});